var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfileColourProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: " M 4.4 8.3 Q 4.05 8.65 4.05 9.1 4.05 9.55 4.4 9.9 4.75 10.25 5.2 10.25 5.65 10.25 5.95 9.9 6.3 9.55 6.3 9.1 6.3 8.65 5.95 8.3 5.65 8 5.2 8 4.75 8 4.4 8.3 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: " M 14.7 22.55 L 23.7 22.55 Q 23.8 20.35 22.75 18.7 21.45 16.9 19.2 16.95 17 17 15.8 18.75 14.7 20.35 14.7 22.55 Z M 21.45 13.05 Q 21.45 14 20.8 14.6 20.15 15.3 19.2 15.3 18.25 15.3 17.6 14.6 16.95 14 16.95 13.05 16.95 12.1 17.6 11.4 18.25 10.8 19.2 10.8 20.15 10.8 20.8 11.4 21.45 12.1 21.45 13.05 Z M 12.45 20.35 L 2.4 20.35 2.4 6.85 4.6 6.85 Q 4.45 3.55 6.85 3.5 L 13.6 3.5 Q 16.05 3.45 15.85 6.85 L 19.2 6.85 19.2 9.1 M 14.7 13.6 Q 14.7 15.2 13.55 16.35 12.4 17.5 10.8 17.5 9.15 17.5 8 16.35 6.85 15.2 6.85 13.6 6.85 11.95 8 10.8 9.15 9.65 10.8 9.65 12.4 9.65 13.55 10.8 14.7 11.95 14.7 13.6 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileColourProfile);
export default __webpack_public_path__ + "static/media/icon-profile-colour-profile.2ae78cf1605b73114e584b8c5fa062f6.svg";
export { ForwardRef as ReactComponent };